import { toUserMultiValue, UserMultiValuedList } from '../../../User'
import { getEmailParticipants } from '../../Email.utils'

import * as styles from './EmailAttachedTagParticipants.module.css'

function EmailAttachedTagParticipants({ lastMessage }) {
  const participants = getEmailParticipants(lastMessage).map(toUserMultiValue)

  return (
    <div className={styles.participants}>
      <UserMultiValuedList items={participants} />
    </div>
  )
}

export default EmailAttachedTagParticipants
